// extracted by mini-css-extract-plugin
module.exports = {"rating-option":"styles-module__rating-option___1CPqa"};